import request from '@/utils/http';
import { getSession, setSession } from '@/components/utils/storage';
import store from '@/store';

function getDictCache(keysStr) {
    if (!keysStr) {
        return {
            result: {},
            passKeys: ''
        };
    }
    const keys = keysStr.split(',');
    const result = {};
    const passKeys = [];
    keys.forEach(key => {
        const val = getSession(key);
        if (val) {
            result[key] = val;
        } else {
            passKeys.push(key);
        }
    });
    return {
        result,
        passKeys: passKeys.join(',')
    };
}
function setDictCache(map) {
    Object.keys(map).forEach(key => {
        setSession(key, map[key]);
    });
}

// 库区列表
export const getList = {
    post(url, params) {
        return request({
            url: url + '/userIndividualConfigs/saveOrUpdate',
            method: 'post',
            data: params
        });
    },
    get(url, params) {
        return request({
            url: url + '/userIndividualConfigs/param',
            method: 'post',
            data: params
        });
    }
};
export const dictionaryItem = (params) => {
    const appInfo = {
        tenantCode: store.getters.currentTenant.tenantCode,
        languageType: store.getters.locale || 'zh-CN'
    };
    return request({
        url: '/api-ds/dictionaryDetail/dict',
        method: 'get',
        params: { ...params, ...appInfo }
    });
};
// 字典值
export const dict = (popPrefix, params) => {
    const type = Object.prototype.toString.call(params);
    let dictCodes = null;
    if (type === '[object String]') {
        dictCodes = params;
    } else {
        dictCodes = params.dictCodes;
    }
    const data = getDictCache(dictCodes);
    if (data.passKeys === '') {
        return new Promise(resolve => {
            resolve({
                code: '0',
                data: data.result
            });
        });
    } else {
        return request({
            url: popPrefix,
            method: 'get',
            params: {
                // 不区分租户
                tenantCode: store.getters.currentTenant.tenantCode,
                dictCodes: data.passKeys,
                languageType: store.getters.locale || 'zh-CN'
            }
        }).then(res => {
            setDictCache(res.data);
            res.data = { ...data.result, ...res.data };
            return res;
        });
    }
};
export const dictWithUrl = (params) => {
    return dict('/api-ds/dictionaryDetail/dict', params);
};

// 远程搜索
export const longRange = (longPrefix, params) => {
    return request({
        url: longPrefix,
        method: 'post',
        data: params
    }).then(res => res);
};
